import { createApp } from 'vue'
import NoticeBoardBase from '@/vue/components/NoticeBoardBase.vue'
import Buefy from '@/js/services/buefy'

document.addEventListener('DOMContentLoaded', () => {
  const element = document.querySelector('#vue-notice-board')

  if (element) {
    const app = createApp(NoticeBoardBase)
    Buefy(app)

    app.provide('dataset', element.dataset)
    app.mount('#vue-notice-board')
  }
})
